import {
  BaseSyntheticEvent,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
} from 'react';

import { useAppDispatch } from '../../../../../../store/hooks';
import { ReactComponent as WarningIcon } from '../../../../assets/icons/snackbar-icons/warning.svg';
import { useSnackbarContextState } from '../../../../hooks/use-snack-bar-context-state/use-snackbar-context-state.hook';
import { DragAndDropProps } from '../../models/drag-and-drop.model';
import { preventDefaults } from '../../util/prevent-defaults/prevent-defaults.util';
import { useRemoveFile } from '../use-remove-file/use-remove-file.hook';

export const useHandleRemoveFile = (
  props: PropsWithChildren<DragAndDropProps>,
  setFiles: Dispatch<SetStateAction<File[]>>
): ((event: BaseSyntheticEvent, index: number) => Promise<void>) => {
  const dispatch = useAppDispatch();
  const snackBarConfig = useSnackbarContextState();
  const removeFile = useRemoveFile(props, setFiles);

  return async (event: BaseSyntheticEvent, index: number): Promise<void> => {
    preventDefaults(event);
    if (props.deleteFileHandler && props.files) {
      try {
        await dispatch(props.deleteFileHandler(props.files[index].id)).unwrap();
        removeFile(index);
      } catch {
        snackBarConfig(
          'error',
          'Something went wrong while removing the file',
          <WarningIcon />,
          true
        );
      }
      return;
    }
    removeFile(index);
  };
};
